export default __webpack_public_path__ + "static/media/india.b9d21c8f.png";